<template>
    <ui-modal
        icon="far fa-cog"
        name="commission-rules"
        title="Regras de Comissão"
        size="lg"
    >
        <div class="commission-rules scroll-color">
            <div class="register-rules">
                <div class="modal-title">Cadastrar Comissão</div>
                <!-- @start .register-rules-form -->
                <form class="register-rules-form">
                    <ui-overlay-load v-if="loadingEditing" />
                    <div class="form-row">
                        
                        <div class="col">
                            <ui-select v-model="form.data.rule" label="Tipo" required :clearable="false" line-height>
                                <option
                                    v-for="(type, index) in commissionTypesOptions"
                                    :key="index"
                                    :value="type.label"
                                    :selected="form.data.rule === type.label">
                                    {{ type.label }}
                                </option>
                            </ui-select>
                        </div>
                        <div v-if="form.data.rule === 'Vinculada ao Perfil'" class="col">
                            <ui-select
                                v-model="form.data.profile"
                                label="Perfil de usuário"
                                required
                                line-height
                                :clearable="false">
                                <optgroup label="Sistema">
                                    <option
                                        v-for="(data, index) in dataGroupsComputed.profiles"
                                        :key="index"
                                        :value="data.value"
                                        :selected="form.data.profile === data.value">
                                        {{ data.label }}
                                    </option>
                                </optgroup>
                                <optgroup v-if="dataGroupsComputed.dynamics != '' " label="Dinâmico">
                                    <option
                                        v-for="data in dataGroupsComputed.dynamics"
                                        :key="data.id"
                                        :value="data.name"
                                        :selected="form.data.profile === data.name">
                                        {{ data.name }}
                                    </option>
                                </optgroup>
                            </ui-select>
                        </div>

                        <div v-if="form.data.rule === 'Representativo'" class="col">
                            <ui-input
                                v-model="form.data.profile"
                                label="Perfil de usuário"
                                required
                            />
                        </div>

                        <div class="col">
                            <ui-input
                                v-model="form.data.value"
                                type="tel"
                                label="Total a ser recebido"
                                group="%" 
                                percent
                                required
                            />
                        </div>
                    </div>
                    <div v-if="form.editing" class="buttons">
                        <div v-show="form.message" v-add-html="form.message" class="message"/>
                        <ui-button design="danger md" @click="clearForm">Cancelar edição</ui-button>
                        <ui-button design="success md" @click="submit">Salvar alterações</ui-button>
                    </div>

                    <div v-else class="buttons">
                        <div v-show="form.message" v-add-html="form.message" class="message"/>
                        <ui-button design="primary md mw-150" :loading="loadingAddComission" @click="submit">
                            Adicionar comissão
                        </ui-button>
                    </div>
                </form>
                <!-- @end .register-rules-form -->

                <ui-no-content-box
                    v-if="rules.length == 0"
                    :load="load"
                    :reload-btn="false"
                    icon="far fa-file"
                    text="Não encontramos nenhuma comissão"
                    :max-height="200" 
                />

                <!-- @start .register-rules-table -->
                <div v-if="!load && rules.length" class="register-rules-table">
                    <ui-overlay-load v-if="loadingTableUpdate" />

                    <div class="ui-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Regras</th>
                                    <th>Perfil de usuário</th>
                                    <th>Valor <small>(%)</small></th>
                                    <th width="40">&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ui-table-line
                                    v-for="(rule, index) in rules"
                                    :key="rule.id"
                                    :data="rule"
                                    :index="index"
                                    :selected="form.editingIndex"
                                    @edit="editLineHandler"
                                    @remove="removeLineHandler"/>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- @end .register-rules-table -->
            </div>
        </div>
    </ui-modal>
</template>
 
<script>
import { uiButton } from "@/components/ui/buttons"
import { uiInput, uiSelect } from "@/components/ui/form"
import { uiModal } from "@/components/ui/modal"
import uiTableLine from "@/components/ui-facilita/products/step-four/commission-rules/table-line"
import { mapGetters } from "vuex"
import { offline, user, salesTable, commissionRules } from "@/services/axios"
import { uiNoContentBox, uiOverlayLoad } from '@/components/ui'



const defaultFormData = (data) => {
    return {
        id: null,
        sales_table_id: data.id,
        rule: null,
        profile: null,
        value: null
    }
}
export default {
    name:"cossion-rules",
    components: {
        uiButton,
        uiModal,
        uiInput,
        uiSelect,
        uiTableLine,
        uiNoContentBox,
        uiOverlayLoad,        
    },
    
    data() {
        return {
            load: true,
            loadingTableUpdate: false,
            loadingAddComission: false,
            loadingEditing: false,
            form: {
                message: '',
                editingIndex: null,
                editing: false,
                fields: {
                    rule: {
                        required: true
                    },
                    profile: {
                        required: true
                    },
                    value: {
                        required: true
                    }
                },
                data: {}
            },
            rules: [],
            commissionTypesOptions: [
                { label: "Vinculada ao Perfil" },
                { label: "Representativo" },
            ],
            dataGroups: {
              usersDynamics: [],
              users: []
            },
            unsubscribe: null
        }
    },

    computed: {
        ...mapGetters("salesTable", {
            salesTableConfig: "getSalesTableConfig",
        }),
        dataGroupsComputed() {
            let groups = {
                dynamics: [],
                profiles: []
            }

            if (this.rules && this.rules.length) {
                const rules = Object.values(this.rules).map(rule => rule.profile)
                groups.dynamics = Object.values(this.dataGroups.usersDynamics)
                    .filter(group => {
                        if (this.form.editing && this.form.data.profile === group.name) return true
                        
                        return !rules.includes(group.name)
                    })
                groups.profiles = Object.values(this.dataGroups.users)
                    .filter(group => {
                        if (this.form.editing && this.form.data.profile === group.value) return true
                        
                        return !rules.includes(group.value)
                    })

            } else {
                groups.dynamics = [...this.dataGroups.usersDynamics]
                groups.profiles = [...this.dataGroups.users]
            }

            return groups
        }
    },
    created() {
        this.$root.$on("modal-close-commission-rules", () => {
            setTimeout(() => {
                this.rules = []
                this.form.message = ''
                this.load = true
            }, 400);
        })
            
        offline.getLabels()
            .then((response) => {
                this.dataGroups.users = [...Object.values(response.data)]
            })
            .catch((error) => {
                if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                console.log('error', error)
            })

        user.readDynamics()
            .then((response) => {
                this.dataGroups.usersDynamics = [...response.data]
            })
            .catch((error) => {
                if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                console.log('error', error)
            })

        /** Subscreve para uma mutation */
        this.unsubscribe = this.$store.subscribe((mutation) => {
            /** Atualiza o conteúdo da tabela */
            if (mutation.type === "salesTable/SET_SALES_TABLE_CONFIG") {
                this.$set(this.form, 'data', defaultFormData(this.salesTableConfig))
                this.getModalConfig()
            }
        })
    },

    beforeDestroy() {
        this.unsubscribe()
    },

    methods: {
        getModalConfig() {
            salesTable.getCommissionRules(this.salesTableConfig.id)
                .then((response) => {
                    this.rules = [...response.data]
                    this.load = false
                })
                .catch((error) => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log('error', error)
                })
        },
        /**
         * Valida a propriedade required dos campos do formulário
         */
        validateRequired(field) {
            const required = this.form.fields[field].required
            const validation = this.form.data[field] || parseInt(this.form.data[field]) === 0

            return (required && validation) || !required
        },
        /**
         * Valida os campos do formulário de acordo com diferentes conjuntos de regras
         */
        validateForm() {
            let valid = true
            let message = '<ul>'

            if (!this.validateRequired('rule')) {
                valid = false
                message += '<li>É necessário selecionar a regra.</li>'
            }

            if (!this.validateRequired('profile')) {
                valid = false
                message += '<li>É necessário informar o perfil do usuário.</li>'
            }

            if (!this.validateRequired('value')) {
                valid = false
                message += '<li>É necessário informar o total a ser recebido.</li>'
            }

            if (String(this.form.data.sales_table_id).includes('random')
                || !this.form.data.sales_table_id) {
                valid = false
                message += '<li>É necessário salvar a tabela de vendas antes de criar as regras de comissão.</li>'
            }

            message += '</ul>'

            return { valid, message }
        },
        submit() {
            const validation = this.validateForm()

            if (validation.valid) {
                this.$set(this.form, 'message', '')
                this.submitForm()
            } else {
                this.$set(this.form, 'message', validation.message)
            }
        },
        submitForm() {
            this.loadingAddComission = true
            this.loadingTableUpdate = true

            if (this.form.data.id) {
                commissionRules.update('' , this.form.data.id, this.form.data)
                    .then(response => {
                        this.$set(this.rules, this.form.editingIndex, { ...response.data.data })
                        this.$toastr.s(response.data.msg)
                        this.clearForm()
                        this.loadingAddComission = false
                        this.loadingTableUpdate = false
                    })
                    .catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                        this.loadingAddComission = false
                        this.loadingTableUpdate = false
                    })
            } else {
                commissionRules.create('' , this.form.data)
                    .then(response => {
                        this.$set(this.rules, this.rules.length, { ...response.data.data })
                        this.$toastr.s(response.data.msg)
                        this.clearForm()
                        this.loadingAddComission = false
                        this.loadingTableUpdate = false
                    })
                    .catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                        this.loadingAddComission = false
                        this.loadingTableUpdate = false
                    })
            }
        },
        clearForm() {
            this.$set(this.form, 'data', defaultFormData(this.salesTableConfig))
            this.$set(this.form, 'editing', false)
            this.$set(this.form, 'editingIndex', null)
        },
        editLineHandler(value) {
            this.loadingEditing = true

            this.form.editing = true
            this.form.editingIndex = value.index
            this.$set(this.form, 'data', { ...value.data })

            setTimeout(() => {
                this.loadingEditing = false
            }, 809);
        },
        removeLineHandler(value) {
            this.loadingTableUpdate = true

            commissionRules.delete('' , value.id)
                .then(response => {
                    this.$delete(this.rules, value.index)
                    this.$toastr.s(response.data.msg)
                    this.clearForm()
                    this.loadingTableUpdate = false
                })
                .catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log('error', error)
                    this.loadingTableUpdate = false
                })
        }
    },
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>